import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { PortalPage, EmptyState } from "../../components/portal/PortalPage";
import { usePortal } from "../../components/portal/usePortal";
import { SubClientOverview } from "../../components/portal/SubClientOverview";
import { CardListSkeleton } from "../../components/Skeletons";
import { Lightning, Plus, Buildings } from "@phosphor-icons/react";

/* Main-client portal: one sub-client's full picture — header, live counters and tabbed lists of their work. */
export default function ClientSubClientDetailPage() {
  const { id } = useParams();
  const { perms } = usePortal();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setData(null); setError("");
    API.get(`/client-hub/sub-clients/${id}`).then(({ data }) => setData(data)).catch((e) => setError(formatApiError(e?.response?.data?.detail) || "Could not load this sub-client"));
  }, [id]);

  if (error) return <PortalPage title="Sub-client" back={{ to: "/portal/sub-clients", label: "All sub-clients" }} testid="sub-client-detail-error"><EmptyState icon={Buildings} title="Not available" text={error} /></PortalPage>;
  const c = data?.client;
  return (
    <PortalPage
      title={c ? <span className="inline-flex items-center gap-2.5">{c.colour && <span className="h-4 w-4 rounded-full shrink-0 ring-2 ring-white/80 shadow-sm" style={{ background: c.colour }} title="This client's colour across the portal" data-testid="sub-client-detail-colour" />}{c.display_name}</span> : "Sub-client"}
      subtitle={c ? [c.contact_name, c.portal_enabled ? "Portal enabled" : "Portal disabled"].filter(Boolean).join(" · ") : ""}
      back={{ to: "/portal/sub-clients", label: "All sub-clients" }}
      testid="sub-client-detail-page"
      actions={perms.can_request && c && (
        <>
          <Button variant="destructive" size="sm" onClick={() => navigate(`/portal/emergencies/new?for=${c.id}`)} data-testid="sub-new-emergency"><Lightning size={14} className="mr-1" weight="fill" /> Emergency for {c.display_name.split(" ")[0]}</Button>
          <Button size="sm" onClick={() => navigate(`/portal/requests/new?for=${c.id}`)} data-testid="sub-new-request"><Plus size={14} className="mr-1" /> New request</Button>
        </>
      )}
    >
      {!data ? <CardListSkeleton rows={4} showHeader={false} /> : <SubClientOverview data={data} />}
    </PortalPage>
  );
}
